import { useMutation, useQueryClient } from '@tanstack/react-query';
import { getGetUserEmailOptionsQueryKey, resendVerificationEmail, updateUserEmailOptions } from 'ze-sdk';
export function useSaveEmailsSettings() {
    const queryClient = useQueryClient();
    const queryKey = getGetUserEmailOptionsQueryKey();
    return useMutation({
        mutationFn: (data)=>updateUserEmailOptions(data),
        onSuccess: async ()=>{
            await queryClient.invalidateQueries({
                queryKey
            });
        }
    });
}
export function useSendEmailVerification() {
    const queryClient = useQueryClient();
    const queryKey = getGetUserEmailOptionsQueryKey();
    return useMutation({
        mutationFn: ()=>resendVerificationEmail(),
        onSuccess: async ()=>{
            await queryClient.invalidateQueries({
                queryKey
            });
        }
    });
}
export function useMakeEmailDefault() {
    const queryClient = useQueryClient();
    const queryKey = getGetUserEmailOptionsQueryKey();
    return useMutation({
        mutationFn: (email)=>updateUserEmailOptions({
                defaultEmail: email
            }),
        onSuccess: async ()=>{
            await queryClient.invalidateQueries({
                queryKey
            });
        }
    });
}
